import React from 'react';
import _ from 'lodash';
import { Modal, Card, CardContent, CardHeader, IconButton, Button, Portal, LinearProgress } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { SmallFormDateField } from '../../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../../services/functions';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function EventDateRangeModal ({ handleClose, eventDateFrom, setEventDateFrom, eventDateTo, setEventDateTo, handleSubmit, isLoading }) {

  return (
    <Portal>
      <Modal open={true}>
        <Card sx={{ ...style, minWidth: '500px', display: 'flex', flexDirection: 'column' }}>
          <CardHeader
            title="Wygeneruj raport"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <SmallFormDateField
              sx={{ width: '100%', mb: 2 }}
              type="text"
              label="Data końca imprezy od"
              variant="standard"
              value={eventDateFrom}
              onChange={val => setEventDateFrom(formatDate(val))}
            />
            <SmallFormDateField
              sx={{ width: '100%', mb: 2 }}
              type="text"
              label="Data końca imprezy do"
              variant="standard"
              value={eventDateTo}
              onChange={val => setEventDateTo(formatDate(val))}
            />
            {isLoading
              ? <LinearProgress sx={{ my: 2 }}/>
              : <Button
                variant="contained"
                onClick={handleSubmit}
                fullWidth
              >
                Generuj
              </Button>}
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
